<template>
    <div class="ourselves">
        <div class="img-header">
            <img src="@/assets/image/ourselves.png" alt="联系我们" class="ourselves-image" />
        </div>
        <div class="gray-section">
            <div class="white-card">
                <h2>百亩林农业科技发展有限公司</h2>
                <p>联系方式: 123-456-7890</p>
                <p>邮箱: contact@example.com</p>
                <p>地址: 某市某区某路某号</p>
            </div>
        </div>
        <!-- <div class="contact-form">
            <h2>在线留言</h2>
            <div class="additional-section2">
            </div>
            <form @submit.prevent="submitForm">
                <div class="form-row">
                    <div class="form-group">
                        <label for="name">姓名</label>
                        <input type="text" id="name" v-model="formData.name" required />
                    </div>
                    <div class="form-group">
                        <label for="phone">手机</label>
                        <input type="tel" id="phone" v-model="formData.phone" required />
                    </div>
                </div>
                <div class="form-row">
                    <div class="form-group">
                        <label for="email">邮箱</label>
                        <input type="email" id="email" v-model="formData.email" required />
                    </div>
                    <div class="form-group">
                        <label for="address">地址</label>
                        <input type="text" id="address" v-model="formData.address" required />
                    </div>
                </div>
                <div class="form-group">
                    <label for="message">留言内容</label>
                    <textarea id="message" v-model="formData.message" required></textarea>
                </div>
                <button type="submit">提交</button>
            </form>
        </div> -->
        <div class="additional-section">
        </div>
        <div class="footer-section">
            <div class="footer-left">
                <p>版权所有 © 2025 百亩林</p>
                <router-link to="/honour" class="license-link">营业执照</router-link>
            </div>
            <div class="footer-right">
                <p>备案号：XYZ123456789</p>
                <!-- <div class="qr-code">
                    <img src="@/assets/image/logo.png" alt="二维码" class="qr-image" />
                </div> -->
            </div>
        </div>
    </div>
</template>

<script>
import Footer from '@/components/Footer.vue'; // 引入 Footer 组件
export default {
    name: 'Ourselves',
    components: {
        Footer,
    },
    data() {
        return {
            formData: {
                name: '',
                phone: '',
                email: '',
                address: '',
                message: ''
            }
        };
    },
    methods: {
        submitForm() {
            if (this.formData.address.trim() === '') {
                alert('地址不能为空');
                return;
            }
           // 发送数据到服务器
           fetch('http://localhost:3000/messages/submit-message', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(this.formData)
            })
            .then(response => response.text())
            .then(data => {
                alert(data);
                // 清空表单
                this.formData = {
                    name: '',
                    phone: '',
                    email: '',
                    address: '',
                    message: ''
                };
            })
            .catch(error => {
                console.error('Error submitting form:', error);
                alert('留言提交失败，请重试');
            });
        }
    }
}
</script><style scoped>
.ourselves {
    text-align: center;
    padding-top: 40px;
}

.img-header {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}

.ourselves-image {
    max-height: 250px; /* 修改为250px */
    width: 100%;
}

.gray-section {
    background-color: #f0f0f0; /* 浅灰色背景 */
    height: 450px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.white-card {
    background-color: white; /* 白色背景 */
    width: 70%;
    height: 250px;
    padding: 20px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1); /* 添加阴影效果 */
    border-radius: 8px; /* 圆角 */
    display: flex;
    flex-direction: column;
    justify-content: left;
    align-items: center;
    text-align: left;
}

.white-card h3 {
    margin-bottom: 10px;
}

.white-card p {
    margin: 5px 0;
}

.contact-form {
    margin: 40px 0;
    padding: 20px;
    background-color: white; /* 设置表单背景色为白色 */
    border-radius: 8px;
    width: 100%;
    max-width: 1250px;
    margin: 0 auto;
}

.contact-form h3 {
    margin-bottom: 20px;
}

.form-row {
    display: flex;
    justify-content: space-between;
    margin-bottom: 15px;
}

.form-group {
    width: 48%; /* 每个表单项占48%宽度，留出2%的间距 */
    text-align: left;
}

.form-group label {
    display: block;
    margin-bottom: 5px;
}

.form-group input,
.form-group textarea {
    width: 100%;
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 4px;
    box-sizing: border-box;
}

.form-group textarea {
    height: 100px;
}

button {
    background-color: #28a745;
    color: white;
    padding: 10px 20px;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    margin-top: 25px;
    width: 150px;
}

button:hover {
    background-color: #218838;
}

.footer-section {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px;
    border-top: 1px solid #ccc;
}

.footer-left {
    flex: 1;
    text-align: left;
}

.footer-left p {
    margin: 5px 0;
}

.footer-left .license-link {
    color: blue;
    text-decoration: none;
}

.footer-right {
    flex: 1;
    text-align: right;
}

.footer-right p {
    margin: 5px 0;
}

.qr-code {
    display: flex;
    justify-content: flex-end;
    align-items: center;
}

.qr-image {
    width: 100px;
    height: 100px;
    object-fit: cover;
    margin-top: 10px;
}

.additional-section {
    height: 60px; /* 设置高度 */
    background-color: white; /* 可选：设置背景颜色 */
    margin: 20px 0; /* 可选：设置上下间距 */
}
.additional-section2 {
    height: 10px; /* 设置高度 */
    background-color: white; /* 可选：设置背景颜色 */
    margin: 20px 0; /* 可选：设置上下间距 */
}

/* 移动端适配 */
@media screen and (max-width: 768px) {
    .ourselves {
        padding-top: 20px;
    }

    .img-header {
        margin-bottom: 15px;
    }

    .ourselves-image {
        max-height: 200px;
    }

    .gray-section {
        height: auto;
        padding: 20px 0;
    }

    .white-card {
        width: 90%;
        height: auto;
        min-height: 200px;
        padding: 15px;
    }

    .white-card h2 {
        font-size: 1.5em;
        margin-bottom: 15px;
    }

    .white-card p {
        font-size: 14px;
        margin: 8px 0;
    }

    .footer-section {
        padding: 15px;
    }

    .footer-left p,
    .footer-right p {
        font-size: 14px;
    }
}

@media screen and (max-width: 480px) {
    .ourselves {
        padding-top: 15px;
    }

    .img-header {
        margin-bottom: 10px;
    }

    .ourselves-image {
        max-height: 150px;
    }

    .gray-section {
        padding: 15px 0;
    }

    .white-card {
        width: 95%;
        min-height: 180px;
        padding: 12px;
    }

    .white-card h2 {
        font-size: 1.3em;
        margin-bottom: 12px;
    }

    .white-card p {
        font-size: 13px;
        margin: 6px 0;
    }

    .footer-section {
        padding: 12px;
    }

    .footer-left p,
    .footer-right p {
        font-size: 13px;
    }
}
</style>